module.exports = __webpack_public_path__ + "img/message-log.2d21b55e.png";